import { render, staticRenderFns } from "./TempSave.vue?vue&type=template&id=7608adce&scoped=true"
import script from "./TempSave.vue?vue&type=script&lang=ts"
export * from "./TempSave.vue?vue&type=script&lang=ts"
import style0 from "./TempSave.vue?vue&type=style&index=0&id=7608adce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7608adce",
  null
  
)

export default component.exports